/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterSessionLengthConfigColumn =
  (typeof FilterSessionLengthConfigColumn)[keyof typeof FilterSessionLengthConfigColumn];

export const FilterSessionLengthConfigColumn = {
  conversation_session_length: 'conversation_session_length',
} as const;
